import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {config} from '../../common/config/config';
import Typography from '@mui/material/Typography';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {PostInterface} from "../../interface/post.interface";
import {isMobile} from "react-device-detect";
import {styles} from "../../common/style";
import {useSelector} from "react-redux";
import {RootState} from "../../reducer";
import {common} from "../../common/common";
import {constance} from "../../common/constance/constance";


interface State {
    step1: string,
    step2: string,
}

export default function NaviBox() {
    console.log(`[NaviBox]`);

    const [state, setState] = useState<State>({
        step1: '',
        step2: '',
    });

    const navigate = useNavigate();
    const commonData = useSelector((state: RootState) => state.commonData);
    let {id, workplace, no, page} = common.getQuery();
    let userEmpty = common.isEmpty(commonData.user._id);
    useEffect(() => {
        console.log(window.location.href);
        console.log(window.location.pathname);

        const pathMap: any = config.pathNameMap;
        let step1 = ''
        let step2 = ''
        if (pathMap[window.location.pathname]) {
            if (pathMap[window.location.pathname].step1) {
                step1 = pathMap[window.location.pathname].step1;
                step2 = pathMap[window.location.pathname].step2;
            } else {
                let obj = pathMap[window.location.pathname];
                step1 = obj[id].step1;
                step2 = obj[id].step2;
            }
        }
        setState({
            ...state,
            step1: step1,
            step2: step2,
        })
    }, [window.location.href]);

    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            {/* 네비 */}
            <Box id={'navi'}
                 sx={{
                     display: state.step1 == '' ? 'none' : 'inherit',
                     width: 1,
                     justifyContent: 'center',
                     mt: 1,
                     pl: 2,
                 }}>
                <Box sx={{width: 1, maxWidth: config.maxWidth, display: 'flex'}}>
                    <Typography variant={fontSize} sx={{ color: 'var(--scc-text-secondary)'}}>
                        {`${state.step1}`}
                    </Typography>

                    {state.step2 !== '' ?
                        <>
                            <Typography variant={fontSize} sx={{mr: 1, ml: 1, color: 'var(--scc-text-secondary)'}}>
                                {`>`}
                            </Typography>
                            <Typography variant={fontSize} sx={{ color: 'var(--scc-text-secondary)'}}>
                                {`${state.step2}`}
                            </Typography>
                        </> : ''}
                </Box>
            </Box>
        </>
    );
}

